import { getAdminAuthHeaders } from './adminApi';

const API_BASE_URL = process.env.REACT_APP_GOTTEA_API_BASE_URL || 'https://gottea-search-5gtrn.ondigitalocean.app';

async function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) {
    throw new Error(body.error || body.message || `Request failed with status ${response.status}`);
  }
  return body.data || body;
}

async function request(path, options = {}) {
  const authHeaders = await getAuthHeaders();
  const headers = {
    ...authHeaders,
    ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(options.headers || {}),
  };
  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  return parseResponse(response);
}

export async function fetchPopups() {
  const data = await request('/popups/admin');
  return data.popups || [];
}

export async function createPopup(payload) {
  const data = await request('/popups/admin', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return data.popup;
}

export async function updatePopup(popupId, payload) {
  const data = await request(`/popups/admin/${popupId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  return data.popup;
}

export async function deletePopup(popupId) {
  return request(`/popups/admin/${popupId}`, { method: 'DELETE' });
}

export async function resolvePopupTargetCsv(csvFile) {
  const formData = new FormData();
  formData.append('csv', csvFile);
  const data = await request('/popups/admin/target-users/resolve-csv', {
    method: 'POST',
    body: formData,
  });
  return data;
}

export async function uploadPopupMedia(popupId, mediaFile) {
  const formData = new FormData();
  formData.append('media', mediaFile);
  const data = await request(`/popups/admin/${popupId}/media`, {
    method: 'POST',
    body: formData,
  });
  return data.popup;
}
